import { getApiBaseUrl } from "@/core/environment";
import type { AccessRequestErrorBody, AccessRequestPayload } from "./access.types";

const ACCESS_PATHS = {
  REQUEST: "/api/plataforma/solicitacao-de-acesso",
} as const;

const DEFAULT_ERROR_MESSAGE = "Erro ao enviar solicitação. Tente novamente.";

function getAccessUrl(path: string): string {
  return new URL(path, `${getApiBaseUrl().replace(/\/+$/, "")}/`).toString();
}

async function readErrorMessage(response: Response): Promise<string> {
  try {
    const payload = (await response.json()) as AccessRequestErrorBody;
    if (payload?.message?.trim()) return payload.message.trim();
  } catch {
    // corpo vazio ou não-JSON
  }

  return DEFAULT_ERROR_MESSAGE;
}

/**
 * Envia solicitação pública de acesso ao BFF.
 * Sucesso: HTTP 201 sem body.
 * Erro: status diferente com `{ message }` quando disponível.
 */
export async function submitAccessRequest(payload: AccessRequestPayload): Promise<void> {
  const response = await fetch(getAccessUrl(ACCESS_PATHS.REQUEST), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: payload.email,
      justification: payload.justification,
    }),
  });

  if (response.status === 201) return;

  throw new Error(await readErrorMessage(response));
}
